import React from "react";
import {
  createRoutesFromElements,
  createBrowserRouter,
  Route,
} from "react-router-dom";
import DiagramLayout from "./layouts/AppLayout/DiagramLayout";
import OperationLayout from "./layouts/AppLayout/OperationLayout";
import Gallery from "./pages/gallery";

const routes = createRoutesFromElements(
  <>
    <Route element={<OperationLayout />}>
      <Route path="/" element={<Gallery/>}/>
    </Route>

    <Route path="/editor" element={<DiagramLayout />} />
  </>
);

const router = createBrowserRouter(routes);

export default router;
